import { render } from "./DesktopFooter.vue?vue&type=template&id=5a22d697"
import script from "./DesktopFooter.vue?vue&type=script&lang=js"
export * from "./DesktopFooter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__